import React from "react";
import _ from 'underscore';
import { notifyOverLimits } from "@helpers/notify_over_limits";
import FilestackUploader from "./main";

class UploadArea extends React.Component {
  constructor(...args) {
    super(...args);
    this.onError = this.onError.bind(this);
    this.addFiles = this.addFiles.bind(this);
    this.state = {
      error: false
    };
  }

  get uploadType() {
    return this.props.uploadType.toLowerCase();
  }

  get identifier() {
    // Element on the page the filestack uploader will bind to
    if (this.props.uniqDomElement) {
      return this.props.uniqDomElement;
    } if (this.uploadType === "attachment") {
      return this.props.assetKey;
    } if (this.uploadType === "attachment-version") {
      return this.props.attachment.attachment_key;
    } if (this.uploadType === "section") {
      return this.props.sectionKey;
    }
    return "no-uniqDomElement";
  }

  onError = () => {
    this.setState({ error: true });
    Notify.create({ type: 'error', title: bfTranslate("Error Uploading Files") });
  }

  uploadAssetToSection = (files) => {
    const { activeLabelKey, onAssetProcessing, sectionKey } = this.props;
    const brandfolderKey = BF.fx.brandfolder().key;
    const collectionKey = BF.fx.collection() ? BF.fx.collection().key : null;
    const uploadEndpoint = collectionKey ? `/api/v4/collections/${collectionKey}/assets?fast_jsonapi=true&queue_priority=high`
      : `/api/v4/brandfolders/${brandfolderKey}/assets?fast_jsonapi=true&queue_priority=high`;
    const assetData = [];

    _.each(files, (file, iteratee) => {
      // Account for merged attachments
      if (Array.isArray(file)) {
        assetData.push({
          attachments: file,
          ...activeLabelKey && { labels: [activeLabelKey] },
          name: iteratee,
        });
      } else {
        const asset_name = file.filename.replace(/\.[^/.]+$/, "").replace(/_/g, " ").trim();
        assetData.push({
          attachments: [file],
          ...activeLabelKey && { labels: [activeLabelKey] },
          name: asset_name,
        });
      }
    });

    onAssetProcessing(assetData.length);
    const formData = { data: { attributes: assetData }, section_key: sectionKey };
    $.ajax({
      url: uploadEndpoint,
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify(formData),
      context: this,
      beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", `Bearer ${BF_Token}`);
      },
      success: (response) => {
        this.props.newResources(response);
        if (response?.meta?.over_limits) {
          notifyOverLimits();
        }
        onAssetProcessing(0);
      },
      error: (error) => {
        console.log("Error uploading File(s)", error);
        onAssetProcessing(0);
      }
    });
  }

  uploadAttachmentToAsset = (files) => {
    const { assetKey, onUpload } = this.props;

    onUpload(files);
    Insight.createEvent('added_attachments', assetKey, 'asset');
  }

  uploadAttachmentToAssetNewVersion = (file) => {
    const { attachment } = this.props;
    const attachmentKey = attachment.attachment_key || attachment.id;
    const url = `/api/v4/attachments/${attachmentKey}`;

    const successOptions = {
      type: 'success',
      title: bfTranslate('Success!'),
      text: bfTranslate('Your attachment has been updated!'),
      customClass: 'attachment-updated',
      showConfirmButton: true,
      allowOutsideClick: true
    };

    $.ajax({
      url,
      type: 'PUT',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        data: {
          attributes: {
            filename: (file[0].filename || null),
            url: (file[0].url || null),
            mimetype: (file[0].mimetype || null),
            size: (file[0].size || null),
            external_id: (file[0].external_id || null),
            folder_path: (file[0].folder_path || null),
          }
        }
      }),
      context: this,
      beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", `Bearer ${BF_Token}`);
      },
      success: (response) => {
        window.swal(successOptions, () => { });

        const filename = response.data.attributes.filename;
        const imageUrl = response.data.attributes.url;
        const hoverContent = `<img src='${imageUrl}' style='max-width:230px;max-height:230px;'>`;
        const $attachmentContainer = $(`li.m-edit-attachment[data-attachment-key='${attachment.attachment_key}']`);

        $attachmentContainer.find('span.name-popover').text(filename);
        $attachmentContainer.find('span.name-popover').attr('data-content', hoverContent);

        // update asset image on tab if updating the first attachment on asset modal Edit tab
        if (this.props.attachment.position === 0) {
          $('.j-asset-description img.m-asset-img-thumb').attr('src', imageUrl);
          // bulkRefreshSections([assetKey]);
        }

        // update resource on asset modal Workflow/Status tab
        if (this.props.updateTab) this.props.updateTab(response.data); // workflow and status tabs
        if (this.props.updateVersionUploading) this.props.updateVersionUploading({ versionUploading: false }); // status tab

        // check attachment in on asset modal Workflow/Status tab
        if (this.props.handleToggleCheckinCheckout) {
          this.props.handleToggleCheckinCheckout();
        }
      },
      error: (error) => {
        console.log("Error Updating Attachment", error);

        if (this.props.updateStatusTimelineState) {
          this.props.updateStatusTimelineState({ versionUploading: false });
        }
      }
    });

    // TODO create Insight event
  }

  uploadCustomImage = (files) => {
    // cropping race condition for large files fires multiple callbacks
    if (!files.length) { return; }

    const file = files[0];
    const $parent = $(`.j-upload-settings-well.${this.uploadType}`);

    if (['background-image', 'card-image', 'header-image', 'email-logo-image', 'logo-image', 'favicon-image'].includes(this.uploadType)) {
      $parent.find('.filepicker_object').val(JSON.stringify(file));
      $parent.find('.filepicker-complete .filename').text(file.filename);
      $parent.find('.filepicker-complete .filename').attr('href', file.url);
      $parent.find('.filepicker-complete-pane').addClass('complete');
      $parent.find('.filestack-uploader-component').hide();
    } else if (['thumbnail-override', 'watermark'].includes(this.uploadType)) {
      if (this.uploadType === 'thumbnail-override') {
        // Don't update image if adding watermark, since it will just show the uploaded image
        $(".m-modal-preview .m-asset-img-thumb.m-file-img-thumb").show();
        $(".m-modal-preview .m-asset-img-thumb.m-file-img-thumb").attr("src", file.url);
      } else if (this.uploadType === 'watermark') {
        Notify.create({
          title: bfTranslate("Processing watermark."),
          body: bfTranslate("Changes will be available shortly after clicking 'Update Asset'. Refresh your browser to view."),
          type: "success"
        });
      }
      $('.m-asset-advanced-container').find('.j-upload-settings-well').data(`has-${this.uploadType}`, true);
      $parent.find('.filepicker_object').val(JSON.stringify({ url: file.url, filename: file.filename }));
      $parent.find('.filepicker-complete .filename').text(file.filename);
      $parent.find('.filepicker-complete .filename').attr('href', file.url);
      $parent.find('.filepicker-complete-pane').addClass('complete');
      $parent.find('.filestack-uploader-component').hide();
    }
  }

  genericUpload = (_files) => {
    const files = this.structureFiles(_files);
    if (this.uploadType === 'generic-upload') {
      this.props.genericUpload(files);
    } else if (this.uploadType === "guest_upload") {
      this.props.appendFiles(files);
    }
  }

  filteredFiles = (uploadedFiles) => {
    let files = _.filter(uploadedFiles, (file) => (file.filename.charAt(0) !== "." && !file.filename.match(/thumbs\.db|\.jsx?$/i) && !file.mimetype.match(/application\/javascript|text\/javascript|application\/x-actionscript|text\/x-actionscript|application\/ecmascript|text\/ecmascript|text\/html/i)));
    // sort alphabetically for upload
    files = _.sortBy(files, 'filename');
    files = _.sortBy(files, 'folder_path');
    if (uploadedFiles.length !== files.length) {
      const restricted_files_count = uploadedFiles.length - files.length;
      window.swal({
        title: `${restricted_files_count} ${bfTranslate('Restricted File(s) Detected!')}`,
        text: bfTranslate("We reject certain filetypes, including HTML and Javascript"),
        type: "error"
      });
    }
    return files;
  }

  upload = (_files, uploadFunction) => {
    const files = this.structureFiles(_files);
    // Duplicate Detection
    const formattedNames = files.map((file) => file.filename.replace(/\.[^/.]+$/, ""));

    if (this.uploadType === 'asset' && formattedNames.length !== _.uniq(formattedNames).length) {
      $('html').attr("style", "");
      const sweet_alert_options = {
        title: bfTranslate("Merge Attachments"),
        text: bfTranslate("There are multiple files with the same filename, do you want them merged together?\n\n"),
        type: "warning",
        showCancelButton: true,
        cancelButtonText: bfTranslate("Don't Merge"),
        confirmButtonText: bfTranslate("Merge"),
        closeOnConfirm: true,
        customClass: "merging"
      };
      window.swal(sweet_alert_options, (merge_selected) => {
        if (merge_selected) {
          const uniqFiles = _(files).groupBy((file) => file.filename.replace(/\.[^/.]+$/, ""));
          uploadFunction(uniqFiles);
        } else {
          uploadFunction(files);
        }
      });
    } else {
      uploadFunction(files);
    }
  }

  structureFiles = (files) => files.map((file) => {
    /* eslint-disable no-param-reassign */
    _.map(file, (value, key) => {
      delete file[key];
      // This function scrubs the object's properties to match what we expect server side.
      // It renames keys and stuff. If you change this, you'll likely break something important.
      if (key === "originalPath") { key = "folder_path"; }
      if (key === "uploadId") {
        file.data = { filepicker_upload_id: value };
      } else if (key === "source") {
        file.data = { filepicker_client: value };
      } else if (key === "status" || key === "originalFile") {
        // don't pass these along
      } else if (key === "handle") {
        // Let's combine 'filestack' with the actual value so we can differentiate sources visually.
        // We'll also make sure to do lookups with the word 'filestack'
        file.external_id = `filestack|${value}`;
      } else {
        file[this.snakeCase(key)] = value;
      }
    });
    return file;
  })

  snakeCase = (string) => string.replace(/([A-Z])/g, "_$1").toLowerCase();

  customText = () => {
    if (this.uploadType === 'watermark') {
      return bfTranslate("Drag PNG here or click to browse");
    } if (this.uploadType === 'attachment-version-status') {
      if (this.props.uniqDomElement.indexOf('checkin') > -1) {
        return bfTranslate("Check In & Upload");
      }
      return bfTranslate("To upload a new version of this attachment, drag a file here or click to browse");
    } if (this.uploadType === 'attachment-version-edit') {
      return bfTranslate("To update this attachment, click to browse");
    }
    if (this.props.type === "button") {
      return bfTranslate("Click to browse");
    }
    return bfTranslate("Drag file(s) here or click to browse");
  }

  addFiles(filestackResponse) {
    if (filestackResponse.filesFailed.length > 0) {
      const failedFileNames = filestackResponse.filesFailed.map((file) => file.filename).join(', ');
      window.swal({
        title: bfTranslate('Something went wrong'),
        text: `${filestackResponse.filesFailed.length} ${bfTranslate("file(s) failed to upload")}: ${failedFileNames}`,
        type: "error"
      });
    }
    const files = this.filteredFiles(filestackResponse.filesUploaded);
    switch (this.uploadType) {
      case 'asset':
        return this.upload(files, this.uploadAssetToSection);
      case 'attachment':
        return this.upload(files, this.uploadAttachmentToAsset);
      case 'attachment-version-edit': case 'attachment-version-status':
        return this.upload(files, this.uploadAttachmentToAssetNewVersion);
      case 'background-image': case 'card-image': case 'header-image': case 'logo-image': case 'favicon-image': case 'thumbnail-override': case 'email-logo-image': case 'watermark':
        return this.upload(files, this.uploadCustomImage);
      case 'generic-upload': case 'guest_upload':
        return this.genericUpload(files);
      default:
        return this.upload(files, this.uploadAssetToSection);
    }
  }

  render() {
    if (this.state.error) {
      return (
        <h2 className="filestack-error-prompt">
          {bfTranslate('It looks like there was a problem uploading your assets.')}
          {bfTranslate('Please refresh and try again.')}
        </h2>
      );
    }
    return (
      <div className="filestack-upload-area" id={`filestack-upload-${this.uploadType}-${this.identifier}`}>
        <FilestackUploader
          dropzoneContainerId={`filestack-upload-${this.uploadType}-${this.identifier}`}
          onError={this.onError}
          onSuccess={this.addFiles}
          options={this.props.options}
          text={this.customText()}
          type={this.props.type || 'area'}
        />
      </div>
    );
  }
}

export default UploadArea;
